import { ApplicationsStore } from "./ApplicationsStore";
import { CustomersStore } from "./CustomersStore";
import { LicensesStore } from "./LicensesStore";
import { LicensesInUseStore } from "./LicensesInUseStore";
import { UsersStore } from "./UsersStore";
import { LogsStore } from "./LogsStore";

import Models from "./Models";
import Enums from "./Enums";

class DataStore {
  constructor() {
    this.ApplicationsStore = new ApplicationsStore(Models.Application, this);
    this.CustomersStore = new CustomersStore(Models.Customer, this);
    this.LicensesStore = new LicensesStore(Models.License, this);
    this.UsersStore = new UsersStore(Models.User, this);
    this.LicensesInUseStore = new LicensesInUseStore(Models.LicenseInUse, this);
    this.LogsStore = new LogsStore(Models.Log, this);
    this.Enums = new Enums();
  }
}

export default DataStore;



// WEBPACK FOOTER //
// ./src/Stores/DataStore/index.js